import { createContext, ReactNode, useContext, useEffect, useMemo, useState } from 'react';

export type AdminScrollMode = 'page' | 'viewport';

interface AdminLayoutContextValue {
  scrollMode: AdminScrollMode;
  setScrollMode: (mode: AdminScrollMode) => void;
}

const AdminLayoutContext = createContext<AdminLayoutContextValue | null>(null);

export function AdminLayoutProvider({ children }: { children: ReactNode }) {
  const [scrollMode, setScrollMode] = useState<AdminScrollMode>('page');
  const value = useMemo(() => ({ scrollMode, setScrollMode }), [scrollMode]);

  return <AdminLayoutContext.Provider value={value}>{children}</AdminLayoutContext.Provider>;
}

export function useAdminScrollMode(mode: AdminScrollMode) {
  const { setScrollMode } = useAdminLayoutContext();

  useEffect(() => {
    setScrollMode(mode);
    return () => setScrollMode('page');
  }, [mode, setScrollMode]);
}

export function useAdminLayoutContext() {
  const ctx = useContext(AdminLayoutContext);
  if (!ctx) {
    throw new Error('useAdminLayoutContext must be used within AdminLayoutProvider');
  }
  return ctx;
}
